$(document).ready(() => {
  if (window.innerWidth > 991) return
  const el = document.querySelector('[data-open-mobile-zwb-how-it-works="true"]')
  if (!el) return

  $(el).collapse('show')
})
